// file: CartBundleDetails.jsx
import React, { useEffect, useState } from "react";

import styles from "./CartBundleDetails.module.scss";
import CartBundleTile from "../../components/uiComponents/cartBundleTile/CartBundleTile";
import AddressTile from "../../components/uiComponents/addressTile/AddressTile";
import TimeStamp from "../../components/uiComponents/timeStamp/TimeStamp";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import ToggleSwitch from "../../components/customComponents/toggleSwitch/ToggleSwitch";
import OrderModal from "../../components/customComponents/orderModal/OrderModal";
import { Pending } from "@mui/icons-material";
import { getPackageDetails, getShipment } from "../../store/actions";

const CartBundleDetailsDispatcher = ({ cartBundleId, user }) => {
  const [status, setStatus] = useState("");
  const location = useLocation();
  console.log("cartBundleId", cartBundleId);
  const { id, Status, page, item } = location?.state;
  console.log("user", user);
  const [isOn, setIson] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getShipment({
        cartBundleId: id,
        callback: {
          success: (data) => {
            dispatch(getPackageDetails({ shipmentId: data?.awb }));
          },
        },
      })
    );
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>CART BUNDLE : {id}</h1>
        <div className={styles.statusSelector}>
          {/* {page === "pending" && (
            <ToggleSwitch
              value={"dispatcher"}
              cartBundleId={id}
              status={item?.status}
            />
          )} */}
        </div>
      </div>

      <div className={styles.topSection}>
        <div className={styles.leftTop}>
          <CartBundleTile cartBundleData={cartBundleId} />
        </div>
        <div className={styles.rightTop}>
          <AddressTile
            cartBundleData={cartBundleId}
            status={cartBundleId?.orders[0]?.status}
            cartBundleId={id}
          />
        </div>
      </div>

      <div className={styles.bottomSection}>{/* <TimeStamp /> */}</div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    cartBundleId: state?.orders?.cartBundleId,
    user: state.login?.user,
  };
};
export default connect(mapStateToProps, null)(CartBundleDetailsDispatcher);
